import { Global, css, withTheme } from "@emotion/react";

const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        body {
          font-family: Neuzeit Grotesk Regular;
          color: #325146;
        }
      `}
    />
  );
};

export default withTheme(GlobalStyles);
